<template>
    <Tree
            :disabled="disabled"
            checkable
            @expand="onExpand"
            :expandedKeys.sync="expandedKeys"
            v-model="checkedKeys"
            :treeData="treeData"
            :autoExpandParent="autoExpandParent"
            @select="onSelect"
            @check="onCheck"
            :selectedKeys="selectedKeys"
    />

</template>
<script>
    import {Tree} from 'ant-design-vue'
    export default {
        props:{
            treeData:{
                type: Array,
                default: [],
                required: true,
            },
            disabled:{
                type: Boolean,
                default: false,
            }
        },
        components:{Tree},
        data() {
            return {
                expandedKeys: [],
                checkedKeys: [],
                checkedKeysCopy: [],
                selectedKeys: [],
                autoExpandParent: true,
            }
        },
        mounted(){
        },
        watch:{
          checkedKeysCopy:{
                // immediate:true,
                handler(newArr) {
                  // console.log(newArr)
                    const initData = this.keysRecursion(this.treeData);
                    let showState;
                    // let isEqu = false;
                    if (initData.length > 0 && newArr.length > 0 && initData.length === newArr.length) {
                        const bool = initData.every(item=>newArr.includes(item))
                        showState = bool && 'all'
                    } else {
                        if (Array.isArray(newArr)&&newArr.length===0) {
                            showState = 'none'
                        } else {
                            showState = 'other'
                        }
                    }
                    this.$emit('keyChange',showState)
                }
            }
        },
        methods: {
            keysRecursion(list) {
                let data = [];
                list.map(item => {
                    let childList = [];
                    if (item.children && item.children.length > 0) {
                        childList = this.keysRecursion(item.children)
                    }
                    data = [...data,item.key,...childList]
                })
                return data
            },
            onExpand (expandedKeys) {
                // console.log('onExpand', expandedKeys)
                // if not set autoExpandParent to false, if children expanded, parent can not collapse.
                // or, you can remove all expanded children keys.
                this.expandedKeys = expandedKeys
                this.autoExpandParent = false
            },
            onCheck (checkedKeys,info) {
                // console.log('onCheck', checkedKeys)
                this.checkedKeysCopy = [...checkedKeys,...info.halfCheckedKeys];
              // console.log('checkedKeys', this.checkedKeysCopy)
            },
            onSelect (selectedKeys, info) {
                // console.log('checkedKeys', this.checkedKeys)
                // this.checkedKeys = [...this.checkedKeys,...selectedKeys]
            },
        },
        computed:{
        }
    }

</script>
<style lang="scss" scoped>
</style>
